import { BasketItem, basketItemFactory } from '@df/session/api/basket/basket-item';

declare module '@df/session/api/basket/basket-item' {
    interface IBasketItemData {
        errors?: string[];
        am_giftcard_image_url?: string;
    }
}
export class LocalBasketItem extends BasketItem {
    get warning(): string | undefined {
        const beErrors = this.data.errors;
        if (beErrors?.length) {
            return beErrors[0];
        }
        if (!this.isSalable()) {
            return 'Out of stock';
        }
        if (this.maxQty < 6) {
            return 'Limited stock';
        }
        return undefined;
    }
    get giftCardPersonalisedMessage(): string {
        return this.data?.request?.am_giftcard_message;
    }
    get isGiftcard(): boolean {
        return this.product?.giftCard?.isGiftcard;
    }
    get isVirtual(): boolean {
        return !!this.data?.virtual;
    }
    get isFree(): boolean {
        return !!(this.data.rowPrice === 0);
    }

    get isFreeGift(): boolean {
        return this.data?.request?.options?.ampromo_rule_id && this.isFree;
    }

    get productCanBeRemoved(): boolean {
        return (
            (this.isFree && this.data.errors.length > 0) ||
            (this.isFree && !this.isSalable()) ||
            (!this.isFree && !this.isVirtual) ||
            this.isGiftcard
        );
    }
}
basketItemFactory.instance = LocalBasketItem;
